export default {
    add_card: 'Add Card',
    set_default: 'Set default',
    card_debit: 'Credit / Debit Card',
    type: 'Type',
    confirm_set_default_text:
        'Are you sure you want to set default payment for this card?',
    payment_card_delete_confirm: 'Are you sure you want to delete your card?',
    payment_type_text: 'Are you sure you want to set this method for payment?',
    auto_renew_priority_method: 'Auto Renew Priority Method',
    default: 'Default',
    add_new_card: 'Add New Card',
    agree: 'I agree to the',
    term_conditions: 'terms and conditions',
    add_new_card_hint: {
        KH: 'This method is handled by ABA to securely save your card information for next time payment',
        AE: 'This method is handled by STRIPE to securely save your card information for next time payment',
        TH: 'This method is handled by OMISE to securely save your card information for next time payment',
    },
    accepted_payments: 'We Accept',
    settings: 'More settings',
    card_name: 'Card name',
    card_number: 'Card number',
    card_expiry: 'Card Expiry',
    card_cvc: 'Card CVC',
    card_cvc_hint:
        'This code is a three or four digit number printed on the back or front of credit cards.',
    card_maintenance_message:
        'Credit/Debit card recurring payment is under maintenance, we will be back shortly.',
    pay_invoice: 'Pay invoice',
    payment_method: 'Payment method',
    payway_cards: {
        name: 'Visa/ Mastercard',
        slogan: 'Visa, Mastercard',
    },
    omise_cards: {
        name: 'Visa/ Mastercard',
        slogan: 'Visa, Mastercard',
    },
    stripe_cards: {
        name: 'Visa/ Mastercard',
        slogan: 'Visa, Mastercard',
    },
    stripe_method: {
        name: 'Visa/ Mastercard',
        slogan: 'Visa, Mastercard',
    },
    please_add_new_card: 'Please add new card to pay!',
    aba_mobile: 'ABA Mobile - {fee}',
    aba_mobile_fee: '0% Fee',
    aba_mobile_detail: 'Scan to pay with ABA Mobile',
    union_pay: {
        name: 'UnionPay',
    },
    wire_banking_transfer: 'Wire banking transfer',
    validate_minutes: 'validate in 30 minutes',
    your_account_balance: 'Your account balance',
    use_to_pay: 'Use {balance} to pay',
    not_enough_to_pay: {
        1: 'Not enough to pay',
        2: 'Top-up',
        3: 'now',
    },
    your_promo_credit: 'Your promo credit',
    promo_credit_voucher_warning:
        'Selecting a voucher will not allow you to use promo credit as payment',
    payment_success: 'Payment Success!',
    payment_pending: 'Payment Pending',
    thank_you: 'Thank you',
    banking_transfer_warning:
        'Please copy exactly the transfer description above when you transfer payment to us.',
    update_information: 'Please update your information to continue',
    choose_payment_options: 'Choose Payment Option',
    stripe_allows_payment_hint:
        'Stripe only allows payment starting at {minPrice}, please use your wallet balance or',
    top_up_alert:
        'Please top-up credit to your account, payment gateway accepts a minimum of {amount}.',
    checkout: 'Checkout',
    top_up_now: 'Top-up Now',
    payment_success_description_message: {
        info: 'You have just successfully purchased order {invoiceId} for {total}.',
        hint: 'You can view invoice details by clicking button below.',
    },
    transaction_id_with_value: 'Transaction ID: {transactionId}',
    modal_limit_amount: {
        main_title: 'Over Limit Amount',
        description: 'Please choose a service under {amount}to continue.',
    },
};
